<template>
  <SntTagSuggestions
    :value="value"
    :items="filteredItems"
    :width="width"
    placeholder="แท็ก"
    hide-details
    @input="$emit('input', $event)" />
</template>

<script>
import gql from 'graphql-tag'
import SntTagSuggestions from '../form/SntTagSuggestions.vue'

export default {
  components: {
    SntTagSuggestions
  },
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  apollo: {
    customerTags: {
      fetchPolicy: 'network-only',
      query: gql`
        query {
          setting {
            id
            customerTags
          }
        }
      `,
      update (data) {
        const customerTags = data.setting?.customerTags || []
        return customerTags.map((tag) => ({ value: tag }))
      },
      result ({ data }) {
        this.onLoaded(data)
      }
    }
  },
  data () {
    return {
      customerTags: []
    }
  },
  computed: {
    filteredItems () {
      return this.customerTags
    }
  },
  methods: {
    onLoaded (data) {
      this.$emit('loaded', data)
    }
  }
}
</script>
